// Coda operazioni offline – salva in localStorage
// Ogni operazione: { id, method, path, body, token, description, createdAt }

const KEY = 've_offline_queue';

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
  catch { return []; }
}

function notify() {
  window.dispatchEvent(new CustomEvent('ve_queue_changed'));
}

export function addToQueue(op) {
  const q = getQueue();
  const entry = { ...op, id: `${Date.now()}_${Math.random().toString(36).slice(2)}`, createdAt: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify([...q, entry]));
  notify();
  return entry;
}

export function removeFromQueue(id) {
  const q = getQueue().filter(op => op.id !== id);
  localStorage.setItem(KEY, JSON.stringify(q));
  notify();
}

export function clearQueue() {
  localStorage.removeItem(KEY);
}

export function getPendingCount() {
  return getQueue().length;
}
